var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubscriptionExtra28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#subscription_extra_28)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.206 9.063C12.987 7.48 13.378 6.688 14 6.688c.621 0 1.012.792 1.793 2.375l.26.527c.228.462.342.693.542.838.2.145.454.182.964.256l.582.085c1.747.253 2.62.38 2.813.972.192.59-.44 1.207-1.704 2.439l-.422.41c-.368.36-.553.54-.629.774-.076.235-.033.489.054.997l.1.58c.298 1.74.447 2.609-.056 2.974-.503.366-1.284-.045-2.846-.866l-.52-.274c-.457-.24-.684-.36-.931-.36s-.475.12-.931.36l-.52.274c-1.563.821-2.344 1.232-2.847.866-.503-.365-.354-1.235-.056-2.975l.1-.58c.087-.507.13-.76.054-.996-.076-.234-.26-.414-.63-.774l-.42-.41c-1.264-1.232-1.896-1.848-1.704-2.44.192-.59 1.065-.718 2.812-.972l.582-.084c.51-.074.765-.111.964-.256.2-.145.314-.376.542-.838l.26-.527Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "subscription_extra_28",
    x1: 0,
    y1: 0,
    x2: 28,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionExtra28);
export default __webpack_public_path__ + "static/media/subscription_extra_28.3f22ab08.svg";
export { ForwardRef as ReactComponent };